var map = {
	"./xingtu-q1.png": "4G4p",
	"./xingtu-q2.png": "6pqa",
	"./xingtu-q3.png": "DogE",
	"./xingtu-q4.png": "ei83",
	"./xingtu-q5.png": "IROo",
	"./xingtu-q6.png": "4ee5",
	"./xingtu-q7.png": "mtYD"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "aP7Q";


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img ^\.\/xingtu\-q.*\.png$
// module id = aP7Q
// module chunks = 0